import $ from 'jquery';

class SlideToggle {
    constructor() {
        this.initialize();
        $('.slide-toggle').each(function() {
           var btn = this;
           var content = $(btn).closest('.js-toggle-container').find('.js-collapsible');

           if ( $(btn).hasClass('open') ) {
               console.log(btn);
               content.slideToggle(250, () => {
                   $(btn).text(content.is(':visible') ? 'Collapse' : 'More');
               });
           }
        });
    }

    initialize() {
        $('.slide-toggle').on('click', e => {
            this.$button = $(e.currentTarget);
            this.$content = this.$button.closest('.js-toggle-container').find('.js-collapsible');

            this.$content.slideToggle(250, () => {
                this.$button.toggleClass('open');
                this.$button.text(this.$content.is(':visible') ? 'Collapse' : 'More');
            });
        });
    }

    static init() {
        if ($('.slide-toggle').length > 0) {
            new SlideToggle();
        }
    }
}

export default SlideToggle;
